{
  "id": "campaign-115",
  "name": "Formal Lawns",
  "seed": "campaign:115",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".......ACCA.......",
    "..%%....CC....%%..",
    "..%..t..CC..t..%,.",
    "........CC.....,.,",
    "wwww+www++www+wwww",
    "wwww+www++www+wwww",
    ".~~.....CC..,,,...",
    "....X...CC...X....",
    "x..T..xCCCC...T.x.",
    "CCCCCCCCOOCCCCCCCC",
    ".T.T.t.CCCC.t.T.T.",
    ".......*CC*.......",
    ".......*CC*.......",
    ".......*CC*.......",
    "...Y...TCCT...Y...",
    ".......~CC........",
    "........~.x.......",
    "S.......x........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 11
    },
    {
      "kind": "rabbit",
      "x": 14,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 3
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 16
    },
    {
      "kind": "repair",
      "x": 5,
      "y": 1
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "falls": [
    {
      "x": 4,
      "y": 7,
      "dir": "E",
      "at": 22,
      "length": 3
    },
    {
      "x": 13,
      "y": 7,
      "dir": "W",
      "at": 28,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 115,
  "biome": "estate",
  "par": {
    "reel": 7968,
    "push": 7257,
    "selfPropelled": 6744,
    "tractor": 5630,
    "zeroTurn": 4690,
    "fairway": 3951
  },
  "goldTime": {
    "reel": 7968,
    "push": 6906,
    "selfPropelled": 6372,
    "tractor": 5630,
    "zeroTurn": 4689,
    "fairway": 3747
  },
  "routeTries": {
    "par": {
      "reel": 15,
      "push": 22,
      "selfPropelled": 22,
      "tractor": 14,
      "zeroTurn": 6,
      "fairway": 19
    },
    "gold": {
      "reel": 15,
      "push": 28,
      "selfPropelled": 43,
      "tractor": 14,
      "zeroTurn": 41,
      "fairway": 46
    }
  }
}
